import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { AppThunk, DispatchPaged, DispatchPagedReset } from 'base/src/utils/reducerUtil';
import { LotePedidoService } from '../../../services/lotePedido/lotePedidoService';
import { DELETARPEDIDO, LOTEPEDIDO_CREATE, LOTEPEDIDO_GET, LOTEPEDIDO_GET_BYID, PAGARPEDIDO } from '../../../types/lotePedido/lotePedido';

import { TFunction } from 'i18next';
import { StateType } from 'domain/types/base/base';
import { PagedListResponse } from 'domain/types/global/pagedListResponse';
import { LotePedidoResponse } from '../../../types/lotePedido/lotePedidoResponse';
import { PagedListRequest } from 'domain/types/global/pagedListRequest';
import { LotePedidoRequest } from '../../../types/lotePedido/lotePedidoRequest';
import ValidationResult from 'domain/types/global/validationResult';
import { DeletarPedidoRequest } from '../../../types/lotePedido/deletarPedidoRequest';
import { PagarPedidoService } from '../../../services/pagarPedido/pagarPedidoService';
import { PagarPedidoResponse } from '../../../types/pagarPedido/pagarPedidoResponse';
import { PagarPedidoRequest } from '../../../types/pagarPedido/pagarPedidoRequest';

const _LotePedidoService = new LotePedidoService();
const _PagarPedidoService = new PagarPedidoService();

export function LotePedido(campanhaId: number[], request: PagedListRequest<LotePedidoResponse>, t: TFunction): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(LOTEPEDIDO_GET, DispatchType.LOADING, t("Carregando"), StateType.Local))
		request.data = { ...request.data, CampanhaID: campanhaId } as LotePedidoResponse;


		const asyncResponse = await _LotePedidoService.GetLotes(request)

		if (ResponseValid(asyncResponse)) {
			const paged = (asyncResponse as PagedListResponse<LotePedidoResponse>)
			dispatch(DispatchPaged<LotePedidoResponse>(LOTEPEDIDO_GET, request, paged))
		} else {
			dispatch(DispatchLoading(LOTEPEDIDO_GET, DispatchType.ERROR, t("Erro"), StateType.Local))
		}
	};
}

export function ResetLotePedido(request: PagedListRequest<LotePedidoResponse>, take: number): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchPagedReset<LotePedidoResponse>(LOTEPEDIDO_GET, request, take))
	}
}

export function CreateLote(request: LotePedidoRequest, t: TFunction): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(LOTEPEDIDO_CREATE, DispatchType.LOADING, t("Carregando"), StateType.Local))

		const asyncResponse = await _LotePedidoService.CreateLote(request);

		if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: LOTEPEDIDO_CREATE
			})
		} else {
			dispatch({
				payload: asyncResponse,
				type: LOTEPEDIDO_CREATE
			})
			dispatch(DispatchLoading(LOTEPEDIDO_CREATE, DispatchType.ERROR, "Erro ao criar lote!", StateType.Master))
		}
	};
}

export function LotePedidoById(campanhaId: number, t: TFunction): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(LOTEPEDIDO_GET_BYID, DispatchType.LOADING, t("Carregando"), StateType.Local))

		const asyncResponse = await _LotePedidoService.GetLoteById(campanhaId)

		if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: LOTEPEDIDO_GET_BYID
			})
		} else {
			dispatch({
				payload: asyncResponse,
				type: LOTEPEDIDO_GET_BYID
			})
			dispatch(DispatchLoading(LOTEPEDIDO_GET_BYID, DispatchType.ERROR, "Erro ao carregar detalhes!", StateType.Master));
		}
	};
}

export function DeletarLote(request: DeletarPedidoRequest): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(DELETARPEDIDO, DispatchType.LOADING, 'Deletando lote', StateType.Master))

		const asyncResponse: ValidationResult | Error = await _LotePedidoService.Deletar(request, DELETARPEDIDO)

		if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: DELETARPEDIDO
			});
		} else {
			dispatch({
				payload: asyncResponse,
				type: DELETARPEDIDO
			})
			dispatch(DispatchLoading(DELETARPEDIDO, DispatchType.ERROR, "Erro ao deletar lote!", StateType.Master))
		}
	};
}

function extrairMensagemValidacao(mensagemCompleta: string): string {
	console.log('inferno', mensagemCompleta)
	// Procura por "Erro na validação do duplo fator" e retorna apenas essa mensagem específica
	const padraoValidacao = /Erro na validação do duplo fator/i;

	if (padraoValidacao.test(mensagemCompleta)) {
		return "Erro na validação do duplo fator";
	}

	// Se não encontrou o padrão específico, procura por qualquer "Resposta:" seguido do conteúdo
	const padraoResposta = /Resposta:\s*([^"]*(?:"[^"]*"[^"]*)*)/i;
	const matchResposta = mensagemCompleta.match(padraoResposta);

	if (matchResposta) {
		return matchResposta[1].trim();
	}

	// Fallback: retorna a mensagem original se não encontrar nenhum padrão
	return mensagemCompleta;
}

function gerarMensagemFeedback(response: PagarPedidoResponse[]): { tipo: DispatchType, mensagem: string } {
	const sucessos = response.filter(item => item.Success);
	const erros = response.filter(item => !item.Success);
	const total = response.length;

	if (erros.length === 0) {
		return {
			tipo: DispatchType.SUCCESS,
			mensagem: `✅ Todos os ${total} pagamentos foram processados com sucesso!`
		};
	}

	if (sucessos.length === 0) {
		// Se há apenas um erro, extrai a mensagem específica
		if (erros.length === 1) {
			const mensagemLimpa = extrairMensagemValidacao(erros[0].Mensagem || '');
			return {
				tipo: DispatchType.ERROR,
				mensagem: `❌ ${mensagemLimpa}`
			};
		}

		// Para múltiplos erros, verifica se é erro de validação do duplo fator
		const primeiroErro = erros[0];
		const mensagemLimpa = extrairMensagemValidacao(primeiroErro.Mensagem || '');

		// Se a mensagem limpa é diferente da original, significa que foi um erro de duplo fator
		if (mensagemLimpa === "Erro na validação do duplo fator") {
			return {
				tipo: DispatchType.ERROR,
				mensagem: `❌ ${mensagemLimpa}`
			};
		}

		return {
			tipo: DispatchType.ERROR,
			mensagem: `❌ Todos os ${total} pagamentos falharam!`
		};
	}

	// Para erros parciais, mostra os usuários mas com mensagem limpa do primeiro erro
	const primeiroErro = erros[0];
	const mensagemLimpa = extrairMensagemValidacao(primeiroErro.Mensagem || '');
	const usuariosComErro = erros.slice(0, 3).map(item => item.NomeUsuario).join(', ');
	const maisErros = erros.length > 3 ? ` e mais ${erros.length - 3}` : '';

	return {
		tipo: DispatchType.ERROR,
		mensagem: `⚠️ Processamento parcial: ${sucessos.length} sucessos e ${erros.length} erros. Falhas em: ${usuariosComErro}${maisErros}. Erro: ${mensagemLimpa}`
	};
}

export function PagarLote(request: PagarPedidoRequest): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(PAGARPEDIDO, DispatchType.LOADING, 'Realizando Pagamento', StateType.Master))

		const asyncResponse: PagarPedidoResponse[] | Error = await _PagarPedidoService.Pagar(request, PAGARPEDIDO)

		if (ResponseValid(asyncResponse)) {
			const response = asyncResponse as PagarPedidoResponse[];
			const feedback = gerarMensagemFeedback(response);

			dispatch({
				payload: asyncResponse,
				type: PAGARPEDIDO
			});

			dispatch(DispatchLoading(PAGARPEDIDO, feedback.tipo, feedback.mensagem, StateType.Master));
		} else {
			dispatch({
				payload: asyncResponse,
				type: PAGARPEDIDO
			})
			dispatch(DispatchLoading(PAGARPEDIDO, DispatchType.ERROR, "Erro ao realizar pagamento!", StateType.Master))
		}
	};
}

export function TentarNovamente(request: PagarPedidoRequest): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(PAGARPEDIDO, DispatchType.LOADING, 'Realizando Pagamento Novamente', StateType.Master))

		const asyncResponse: PagarPedidoResponse[] | Error = await _PagarPedidoService.TentarNovamente(request, PAGARPEDIDO)

		if (ResponseValid(asyncResponse)) {
			const response = asyncResponse as PagarPedidoResponse[];
			const feedback = gerarMensagemFeedback(response);

			dispatch({
				payload: asyncResponse,
				type: PAGARPEDIDO
			});

			dispatch(DispatchLoading(PAGARPEDIDO, feedback.tipo, feedback.mensagem, StateType.Master));
		} else {
			dispatch({
				payload: asyncResponse,
				type: PAGARPEDIDO
			})
			dispatch(DispatchLoading(PAGARPEDIDO, DispatchType.ERROR, "Erro ao realizar pagamento!", StateType.Master))
		}
	};
}
